var render = function () { var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"138","height":"108","viewBox":"0 0 138 108"}},[_c('path',{attrs:{"fill":"#B5B5B5","fill-opacity":".2","fill-rule":"evenodd","d":"M136.1 0l.5.8a54 54 0 00-28.2 45.5c0 4.2 1.3 5 5.4 5.8A27 27 0 01137.4 80c0 15.7-12 28.1-29 28.1C90.2 108 77 94.8 77 73.2A77.4 77.4 0 01136 0zm-77 0l.5.8a54 54 0 00-28.2 45.5c0 4.2 1.3 5 5.4 5.8A27 27 0 0160.4 80c0 15.7-12 28.1-29 28.1C13.2 108 0 94.8 0 73.2A77.4 77.4 0 0159.2 0z"}})]) };
module.exports = { render: render };


//////////////////
// WEBPACK FOOTER
// ./assets/_img/icons/icon-quote.svg
// module id = 388
// module chunks = 0